import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';

const BeginnerMCQs = () => {
  const [mcqs, setMcqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  const columns = ['ID', 'Question', 'Option A', 'Option B', 'Option C', 'Option D', 'Correct Answer'];

  useEffect(() => {
    const fetchMCQs = async () => {
      const token = localStorage.getItem('employeeToken');
      if (!token) {
        window.location.href = "/employee-login";
        return;
      }

      try {
        const response = await axios.get(`${apiBaseURL}/api/beginner-mcqs`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setMcqs(response.data);
      } catch (err) {
        setError('Failed to fetch MCQs.');
      } finally {
        setLoading(false);
      }
    };

    fetchMCQs();
  }, [apiBaseURL]);

  if (loading) return <div>⏳ Loading MCQ data...</div>;
  if (error) return <div className="text-red-500 p-4">{error}</div>;

  const data = mcqs.map(mcq => ({
    id: mcq.id,
    question: mcq.question,
    option_a: mcq.option_a,
    option_b: mcq.option_b,
    option_c: mcq.option_c,
    option_d: mcq.option_d,
    correct_answer: mcq.correct_answer,
  }));

  const handleDownloadExcel = () => {
    const now = new Date();

    const formattedDateHeader = now.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    const formattedFileTime = now.toISOString().replace(/T/, '_').replace(/:/g, '-').split('.')[0];
    const fileName = `Beginner_MCQs_Master_List_${formattedFileTime}.xlsx`;

    const excelHeader = [
      ['OrderMinds Freelancing Solutions LLP'],
      ['Beginner MCQs Master List'],
      [`Downloaded on: ${formattedDateHeader}`],
      [], // blank row before table
    ];

    const tableHeaders = columns;
    const tableData = data.map(row =>
      columns.map(col => row[col.toLowerCase().replace(/ /g, '_')])
    );

    const worksheetData = [...excelHeader, tableHeaders, ...tableData];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'MCQs');

    XLSX.writeFile(workbook, fileName);
  };

  const Table = ({ columns, data }) => (
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
        <thead>
          <tr className="bg-gray-200">
            {columns.map((col, index) => (
              <th key={index} className="px-4 py-2 text-left">{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="px-4 py-2 text-center text-gray-500">No data available</td>
            </tr>
          ) : (
            data.map((row, index) => (
              <tr key={index} className="border-b">
                {columns.map((col, idx) => (
                  <td key={idx} className="px-4 py-2">{row[col.toLowerCase().replace(/ /g, '_')]}</td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="flex-1 p-6 bg-gray-100 ml-[17rem]">
      <div className="flex justify-between items-center mb-5">
        <h2 className="text-2xl font-semibold">Beginner MCQs List</h2>
        <button
          onClick={handleDownloadExcel}
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition"
        >
          Download Excel
        </button>
      </div>
      <Table columns={columns} data={data} />
    </div>
  );
};

export default BeginnerMCQs;
